import React, { Children, isValidElement, cloneElement, ReactElement } from 'react'
import { DataTable, DataTableProps, DataTableValueArray } from 'primereact/datatable'
import { Skeleton } from 'primereact/skeleton'
import { ColumnProps } from 'primereact/column'

export function Table<TValue extends DataTableValueArray>({
    children,
    loading,
    emptyMessage,
    ...props
}: DataTableProps<TValue> & { children: ReactElement<ColumnProps>[] }) {
    const renderChildren = () => {
        if (loading) {
            return Children.map(children, (child) => {
                if (isValidElement(child)) {
                    return cloneElement(child, { body: () => <Skeleton /> })
                }
                return child
            })
        }
        return children
    }
    return (
        <DataTable
            tableStyle={{ minWidth: '50rem' }}
            {...props}
            emptyMessage={emptyMessage}
            value={
                loading
                    ? (Array.from({ length: props.rows || 10 }).map((_, index) => ({
                          [props.accessKey || 'id']: index,
                      })) as TValue)
                    : props.value
            }
        >
            {renderChildren()}
        </DataTable>
    )
}
